import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=6e48f84e&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=6e48f84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48f84e",
  null
  
)

export default component.exports